/*@flow*/
import * as t from 'lib/t';
import Section from './templates/Section';
import AsyncTemplate from './templates/AsyncTemplate';
import TagsTemplate from './templates/Tags';
import DateRangeListTemplate from './templates/DateRangeListTemplate';
import * as loaders from 'queries/loaders';
import getFiltersQuery from 'lib/getFiltersQuery';
import * as I from 'immutable';
import StatusesTemplate from './templates/Statuses';
import RangeTemplate from './templates/RangeTemplate';

const config = {
  related: t
    .struct({
      issues: t.list(t.String),
    })
    .opt({
      label: 'Filter by Streetscape Assets',
      template: () => null,
    }),
  status: t.list(t.String).opt({
    label: 'Status',
    template: StatusesTemplate,
    filterName: 'streetscape_issues',
  }),
  category: t.list(t.String).opt({
    legend: 'Category',
    template: AsyncTemplate,
    className: 'streetscape-issue-categories-select-field',
    placeholder: 'Select categories',
    loadValues: (o) => {
      const path = 'streetscapeAssets';
      const fs = getFiltersQuery();
      const filterMap = (fs.get(path, I.Map()): any);
      const filters: {} = filterMap.toJS();
      return loaders.issueCategoryLoader({ ...o, filters });
    },
  }),
  subcategories: t.list(t.String).opt({
    legend: 'Subcategories',
    template: AsyncTemplate,
    className: 'streetscape-issue-subcategories-select-field',
    placeholder: 'Select subcategories',
    loadValues: (o) => {
      const path = 'streetscapeAssets';
      const fs = getFiltersQuery();
      const filterMap = (fs.get(path, I.Map()): any);
      const filters: {} = filterMap.toJS();
      return loaders.issueSubcategoryLoader({ ...o, filters });
    },
  }),
  tags: t.list(t.String).opt({
    label: 'Tags',
    template: TagsTemplate,
    filterName: 'issues',
  }),
  createdAt: t.list(t.Date).opt({
    label: 'Date Created',
    template: DateRangeListTemplate,
  }),
  dateOfIncident: t.list(t.Date).opt({
    label: 'Date of Incident',
    template: DateRangeListTemplate,
  }),
  cost: t.maybe(t.Number).opt({
    label: 'Cost',
    template: RangeTemplate,
  }),
};

export default t.struct(config).opt<any>({
  label: 'Streetscape Issues',
  iconClass: 'fa-exclamation-triangle',
  template: Section,
});
